import AlertModal from './AlertModal';

export {default as AlertModal} from './AlertModal';


// WEBPACK FOOTER //
// ./src/alert-modal/index.js